import React, {Component} from 'react';

class Edit extends Component {

    constructor(props) {
        super(props)

        this.state = {
            username: "jack",
        }

        this.handleClick = this.handleClick.bind(this)

        console.log(this.props.match.params.id)

        //查询字符串/user/edit?bar=baz
        const searchParams = new URLSearchParams(this.props.location.search.substring(1))
        console.log(searchParams.get("bar"))

    }

    componentDidMount() {
        //ajax
        //this.setState({})
    }

    handleClick() {
        this.props.history.push("/user")
    }

    render() {
        return (
            <div>
                <h2>Edit</h2>
                <div>name <input type="text"
                                 value={this.state.username}
                                 onChange={e => {
                                     this.setState({username: e.target.value})
                                 }}
                /></div>
                <div>email <input type="text"/></div>
                <div>
                    <button onClick={this.handleClick}>提交</button>
                </div>
            </div>
        )
    }
}

export default Edit